// extracted by mini-css-extract-plugin
module.exports = {"card":"feature-card_card__vMxWO","title":"feature-card_title__RVjR_","body":"feature-card_body__Cn3HG"};